import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LOGO_URL = 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/b9e0099c33a19326b8165990727f4d26.png';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setTimeout(() => {
      if (email === 'admin@aysegulsert.com' && password === 'admin123') {
        navigate('/admin/dashboard');
      } else {
        setError('E-posta veya şifre hatalı. (Demo: admin@aysegulsert.com / admin123)');
      }
      setLoading(false);
    }, 800);
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Logo" className="h-14 w-auto object-contain mx-auto mb-4" />
          <h1 className="font-serif text-2xl text-warm-dark">Yönetim Paneli</h1>
          <p className="text-warm-light text-xs mt-1">Devam etmek için giriş yapın</p>
        </div>
        <div className="bg-white rounded-2xl border border-cream-deeper p-7">
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div>
              <label className="text-xs font-medium text-warm-mid mb-1.5 block">E-posta</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="admin@aysegulsert.com"
                className="w-full px-4 py-2.5 rounded-xl border border-cream-deeper text-sm text-warm-dark focus:outline-none focus:border-gold" />
            </div>
            <div>
              <label className="text-xs font-medium text-warm-mid mb-1.5 block">Şifre</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="••••••••"
                className="w-full px-4 py-2.5 rounded-xl border border-cream-deeper text-sm text-warm-dark focus:outline-none focus:border-gold" />
            </div>
            {error && <p className="text-xs text-red-500 bg-red-50 rounded-lg px-3 py-2">{error}</p>}
            <button type="submit" disabled={loading}
              className="w-full py-3 bg-gold text-white text-sm font-medium rounded-xl hover:bg-gold-dark transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60 mt-1">
              {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
            </button>
          </form>
        </div>
        <p className="text-center text-xs text-warm-light mt-6 cursor-pointer" onClick={() => navigate('/')}>← Siteye Dön</p>
      </div>
    </div>
  );
}